import {createRouter, createWebHistory} from 'vue-router'

import {auth} from "@/api";
import Login from '@/components/Login'
import Home from '@/components/Home'
import Ticket from '@/components/Ticket'
import TicketDetail from '@/components/TicketDetail'
import Upjang from '@/components/Upjang'
import UpjangDetail from '@/components/UpjangDetail'
import MenuInfo from '@/components/MenuInfo'
import Cart from '@/components/Cart'
import Order from '@/components/Order'
import OrderDetail from '@/components/OrderDetail'
import History from '@/components/History'
import HistoryDetail from '@/components/HistoryDetail'
import NotFound from '@/components/util/NotFound'
import ShortUrl from '@/components/util/ShortUrl'
import Membership from "@/components/Membership";
import PaymentRequest from "@/components/util/PaymentRequest";
import authStore from "@/store/auth";
import commonStore from "@/store/common";
import cartStore from "@/store/cart";

const requireAuth = (to, from, next) => {
  const loginPath = `/login?rPath=${encodeURIComponent(to.path)}`
  if (authStore.state.authInfo.token) {
    next()
  } else {
    alert("간편인증이 필요한 페이지 입니다.")
    next(loginPath)
  }
}

const isAuth = (to, from, next) => {
  if (authStore.state.authInfo.token) {
    auth.isAuth()
        .then(data => {
          console.log(data)
        })
        .catch(err => {
          console.log(err)
        })
  }
  next()
}


const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/m/:shortPath/:dynamicParam?',
      name: 'ShortUrl',
      component: ShortUrl
    },
    { 
      path: '/login',
      name: 'Login',
      component: Login 
    },
    {
      path: '/membership',
      name: 'Membership',
      component: Membership,
      beforeEnter: requireAuth
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: isAuth
    },
    {
      path: '/ticket',
      name: 'Ticket',
      component: Ticket
    },
    {
      path: '/ticket/:tktorgno',
      name: 'TicketDetail',
      component: TicketDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/upjang',
      name: 'Upjang',
      component: Upjang,
      beforeEnter: isAuth
    },
    {
      path: '/upjang/:upjangCode',
      name: 'UpjangDetail',
      component: UpjangDetail,
      beforeEnter: isAuth
    },
    {
      path: '/upjang/:upjangCode/:menuCode',
      name: 'MenuInfo',
      component: MenuInfo,
      beforeEnter: isAuth
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      beforeEnter: isAuth
    },
    {
      path: '/order',
      name: 'Order',
      component: Order
    },
    {
      path: '/order/:saleDate/:billNo/:upjangCode',
      name: 'OrderDetail',
      component: OrderDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/order/history',
      name: 'History',
      component: History,
      beforeEnter: requireAuth
    },
    {
      path: '/order/history/:saleDate/:billNo/:upjangCode',
      name: 'HistoryDetail',
      component: HistoryDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/pay',
      name: 'PaymentRequest',
      component: PaymentRequest
    },
    {
      path: '/:catchAll(.*)',
      component: NotFound 
    }
  ]
})

export default router